<dashboard-frame>
	<div class='navbar-content'>
		[[ navbar-content goes here ]]
	</div>
	<div class="page-content">
		<router-outlet />
	</div>
</dashboard-frame>